var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CFBaseActionFooterUtilities } from '@connectrn/ds-ui-base';
import { CFButton } from '../../components';
import { commonAttrs } from '../../utils';
import { CFActionFooterElements } from './ActionFooter.styles';
import { useCFBreakpoint } from '../../providers';
export const CFActionFooter = (_a) => {
    var { children, items = [], stackActionsOnMobile = false } = _a, rest = __rest(_a, ["children", "items", "stackActionsOnMobile"]);
    const { breakpoint } = useCFBreakpoint();
    const { Content, Actions, Root } = CFActionFooterElements;
    const isInlineLayout = CFBaseActionFooterUtilities.isLayoutInline(items.length, stackActionsOnMobile);
    return (React.createElement(Root, Object.assign({}, commonAttrs(rest)),
        React.createElement(Actions, { inlineLayout: breakpoint['xs'] && isInlineLayout }, items.map((item, i) => (React.createElement(CFButton, Object.assign({ key: `cf-action-footer-item-${i}`, rounded: true, widthPreset: breakpoint['sm-up'] ? 'min-160' : 'half' }, item))))),
        children ? React.createElement(Content, null, children) : null));
};
